import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const getScenarios = (query) => axios.get(toQueryString("api/v1/scenario-managements?", query));

const getScenariosLite = (query) => axios.get(toQueryString("api/v1/scenario-managements/lite?", query));

const getScenariosSimple = (query) => axios.get(toQueryString("api/v1/scenario-managements/simple?", query));

const getScenarioById = (id, query) => axios.get(toQueryString(`api/v1/scenario-managements/${id}?`, query));

const deleteScenario = (id) =>
  axios.delete(`api/v1/scenario-managements/${id}`);

const removeBulk = (ids) => axios.delete("api/v1/scenario-managements/bulk", { data: { ids } });

const updateScenario = (id, params) =>
  axios.put(`api/v1/scenario-managements/${id}`, params);

const updateScenarioVersion = (scenarioVersionId, params) =>
  axios.put(`api/v1/scenario-managements/version/${scenarioVersionId}`, params);

const createScenario = () => axios.post("api/v1/scenario-managements");

const activateScenario = (versionId) =>
  axios.put(`api/v1/scenario-managements/version/${versionId}/activate`);

const discardScenarioChanges = (versionId) =>
  axios.put(`api/v1/scenario-managements/version/${versionId}/discard`);

const getDailyTasks = () => axios.get("api/v1/daily-tasks");

const duplicateScenario = (scenarioId) =>
  axios.post(`api/v1/scenario-managements/${scenarioId}/duplicate`);

const getAlternativeMessages = (originalMessage, alreadyGeneratedMessages) =>
  axios.post(`api/v1/scenario-managements/alternative-messages`, {
    originalMessage,
    alreadyGeneratedMessages,
  });

const getAllMessages = async () => {
  const response = (await axios.get(`api/v1/scenario-managements/all-messages`))
    .data;

  return {
    data: response.data,
  };
};

const getOptionsByMessage = async (message) => {
  const response = (
    await axios.get(`api/v1/scenario-managements/question-responses`, {
      params: {
        message,
      },
    })
  ).data;

  return {
    data: response.data,
  };
};

const getSimulatorResources = (scenarioVersionId) =>
  axios.get(
    `api/v1/scenario-managements/version/${scenarioVersionId}/resources`
  );

const getSources = () =>
  axios.get(
    `api/v1/scenario-managements/sources`
  );

const ApiScenariosManagement = {
  getScenarios,
  getScenarioById,
  deleteScenario,
  removeBulk,
  updateScenario,
  updateScenarioVersion,
  createScenario,
  activateScenario,
  discardScenarioChanges,
  getDailyTasks,
  duplicateScenario,
  getAlternativeMessages,
  getAllMessages,
  getOptionsByMessage,
  getSimulatorResources,
  getScenariosSimple,
  getScenariosLite,
  getSources
};

export default ApiScenariosManagement;